// because NodeList.prototype.forEach doesn't exist in IE11
export const forEach = function(obj, fn) {
   return Array.prototype.forEach.call(obj, fn);
};

// NOTE: when IE11 is deprecated, we can use el.classList.toggle() instead of this
export function classListToggle(el, classNames) {
   forEach(Object.entries(classNames), ([className, flag]) => {
      if (flag) {
         el.classList.add(className);
      } else {
         el.classList.remove(className);
      }
   });
}
